import React from 'react'
import "./hand.scss"

//Imagens:
import ImgHand from "../../../assets/reports/hand.png";
import { useTranslation } from 'react-i18next';

function Hand() {
  const {t} = useTranslation()
  return (
    <div className='container-hand'>
      <div className='img-hand'>
        <img src={ImgHand} alt="" />
      </div>
      <div className='texts-hand'>
        <h1>{t("reports.title")}</h1>
        <p>{t("reports.section_text_1")}</p>
        <p>{t("reports.section_text_2")}</p>
        <a href="/form" style={{ textDecoration: "none" }}>
          <button id='btn-hand'>{t("buttons.demo_btn_alternative_text_1")}</button>
        </a>
      </div>
    </div>
  )
}

export default Hand